module.exports = __webpack_public_path__ + "src/assets/img/share/tips/extroversion/97c3be51bb366f89805316af5581c40c.png";